module.exports = WWOpenData;